import { Form, Input, InputNumber } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ImageModuleUpload from '@/pages/backend/cardCampSettings/recruitPageSettings/ImageModuleUpload';
import NodeRemind from '@/pages/backend/cardCampSettings/nodeSettings/nodeRemind';
import { FC, useContext } from 'react';
import NodeSwitch from '@/pages/backend/cardCampSettings/nodeSettings/nodeSwitch';
import { ESwitchEnum } from '@/pages/backend/cardCampSettings/nodeSettings/switchEnum';
import NodeContext from './nodeContext';

const NodeInfoBasicForm: FC<{ id?: string }> = ({ id }) => {
  const form = Form.useFormInstance();
  const manualReview = Form.useWatch('manualReview', form);
  const { nodeNameArray } = useContext(NodeContext);
  console.log('nodeNameArray是', nodeNameArray);
  return (
    <div>
      <Form.Item
        name="name"
        label="节点名称"
        rules={[
          { required: true, message: '请输入节点名称' },
          {
            validator: (rule, value, callback) => {
              if (nodeNameArray.find((item) => item.name === value && item.id !== id)) {
                return Promise.reject('名称不能重复');
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input maxLength={20} showCount />
      </Form.Item>
      <Form.Item name="description" label="节点简要描述">
        <Input maxLength={20} showCount />
      </Form.Item>
      <Form.Item
        name="reward"
        label="完成基础奖励"
        rules={[{ required: true, message: '请输入完成基础奖励' }]}
      >
        <InputNumber min={0} precision={0} addonAfter="学分" />
      </Form.Item>
      <Form.Item
        name="picture"
        label="节点图片"
        rules={[{ required: true, message: '请上传节点图片' }]}
      >
        <ImageModuleUpload
          imageCrop={{ width: 376, height: 280 }}
          maxSize={0.5}
          help={
            <div className="ant-form-item-explain">
              支持上传文件大小不超过500KB的.png/.jpg格式图片，尺寸为376px * 280px
            </div>
          }
          uploadButton={
            <div>
              <PlusOutlined />
              <p>点击上传</p>
            </div>
          }
        />
      </Form.Item>
      <Form.Item name="remind" label="打卡提醒">
        <NodeRemind />
      </Form.Item>
      <Form.Item name="learn" label="打卡心得">
        <NodeSwitch tips="开启后将在前端展示打卡心得输入框" />
      </Form.Item>
      <Form.Item name="remark" label="学习评价">
        <NodeSwitch tips="开启后将在前端展示学习评价部分" />
      </Form.Item>
      <Form.Item name="manualReview" label="主观题人工审阅">
        <NodeSwitch tips="开启后本节点的主观题需要人工批阅并给出得分，反之提交后即得满分并展示题目解析" />
      </Form.Item>
      {manualReview === ESwitchEnum.open && (
        <Form.Item
          name="reviewer"
          label="批阅人uid"
          rules={[
            { required: true, message: '请输入批阅人uid' },
            { pattern: /^(\d+(,\d+)*)$/, message: '请输入正确格式的' },
          ]}
          help="请输入批阅人uid，多个uid之间用英文逗号分隔"
        >
          <Input />
        </Form.Item>
      )}
    </div>
  );
};
export default NodeInfoBasicForm;
